"use strict";
exports.__esModule = true;
var config_1 = require("../config/config");
var Storage = /** @class */ (function () {
    function Storage() {
        this.store = window[config_1["default"].storeKey];
        this.init();
    }
    Storage.prototype.init = function () {
        this.saveUtmQueryParameters();
    };
    Storage.prototype.saveUtmQueryParameters = function () {
        var utmObj = this.getUtmObj();
        if (Object.keys(utmObj).length <= 1) {
            return;
        }
        var utm = [];
        var utmString = localStorage.getItem(this.store.localstorageKeys.utm);
        if (utmString) {
            utm = JSON.parse(utmString);
        }
        utm.push(utmObj);
        localStorage.setItem(this.store.localstorageKeys.utm, JSON.stringify(utm));
    };
    Storage.prototype.getUtmObj = function () {
        var utmParams = {};
        var params = this.getParams(window.location.search);
        for (var key in params) {
            var value = params[key];
            if (key.includes('utm_')) {
                utmParams[key] = value;
            }
        }
        utmParams['timestamp'] = +new Date();
        return utmParams;
    };
    Storage.prototype.getParams = function (url) {
        var params = {};
        var parser = document.createElement('a');
        parser.href = url;
        var query = parser.search.substring(1);
        var vars = query.split('&');
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split('=');
            params[pair[0]] = decodeURIComponent(pair[1]);
        }
        return params;
    };
    ;
    return Storage;
}());
exports["default"] = Storage;
